if (!customElements.get('promo-card-slider')) {
  class PromoCardSlider extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.pcs__grid');
      if (!this.grid) return;

      this.initArrows();
      this.initDragScroll();
    }

    cardStep() {
      const cell = this.grid.querySelector('.pcs__cell');
      if (!cell) return 0;
      const gap = parseFloat(window.getComputedStyle(this.grid).columnGap) || 0;
      return cell.offsetWidth + gap;
    }

    initArrows() {
      this.prev = this.querySelector('.pcs__arrow--prev');
      this.next = this.querySelector('.pcs__arrow--next');
      if (this.prev) this.prev.addEventListener('click', () => this.grid.scrollBy({ left: -this.cardStep(), behavior: 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.grid.scrollBy({ left: this.cardStep(), behavior: 'smooth' }));

      // Fade the arrow that can't go any further (start / end of the strip).
      this.grid.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    updateArrows() {
      const max = this.grid.scrollWidth - this.grid.clientWidth;
      const atStart = this.grid.scrollLeft <= 1;
      const atEnd = this.grid.scrollLeft >= max - 1;
      if (this.prev) this.prev.classList.toggle('is-disabled', atStart);
      if (this.next) this.next.classList.toggle('is-disabled', atEnd);
      this.updateCounter(max);
    }

    // "current / total" for arrow style 2: positions are one card step apart,
    // the last position being the end of the strip.
    updateCounter(max) {
      const current = this.querySelector('[data-pcs-current]');
      const total = this.querySelector('[data-pcs-total]');
      if (!current || !total) return;
      const step = this.cardStep();
      if (!step) return;
      // Any leftover scroll distance (even half a card) counts as one more
      // position, and reaching the end always reads as the last one.
      const pages = Math.max(1, Math.ceil((max - 1) / step) + 1);
      const atEnd = this.grid.scrollLeft >= max - 1;
      const index = atEnd ? pages : Math.min(pages, Math.round(this.grid.scrollLeft / step) + 1);
      current.textContent = index;
      total.textContent = pages;
    }

    // Mouse drag-to-scroll for desktop (touch devices scroll natively).
    initDragScroll() {
      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      let moved = false;

      this.grid.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        if (this.grid.scrollWidth <= this.grid.clientWidth) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = this.grid.scrollLeft;
      });

      window.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) {
          moved = true;
          this.grid.classList.add('is-dragging');
        }
        this.grid.scrollLeft = startScroll - dx;
      });

      window.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        this.grid.classList.remove('is-dragging');
      });

      // Suppress the click on card links after a real drag.
      this.grid.addEventListener(
        'click',
        (e) => {
          if (!moved) return;
          moved = false;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }
  }
  customElements.define('promo-card-slider', PromoCardSlider);
}
